module.exports = __webpack_public_path__ + "img/ssjk-selected.07393160.png";